import React from "react";

export const Play = (props) => (
  <svg
    {...props}
    width="7"
    height="8"
    viewBox="0 0 7 8"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M0 8V0L7 4.1142L0 8Z" fill="black" />
  </svg>
);

export const Pause = (props) => (
  <svg
    {...props}
    width="7"
    height="8"
    viewBox="0 0 7 8"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect width="3" height="8" fill="black" />
    <rect x="4" width="3" height="8" fill="black" />
  </svg>
);

export const Prev = (props) => (
  <svg
    {...props}
    width="8"
    height="8"
    viewBox="0 0 8 8"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M8 8V0L1 4.1142L8 8Z" fill="black" />
    <rect width="1" height="8" transform="matrix(-1 0 0 1 1 0)" fill="black" />
  </svg>
);

export const Next = (props) => (
  <svg
    {...props}
    width="8"
    height="8"
    viewBox="0 0 8 8"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M0 8V0L7 4.1142L0 8Z" fill="black" />
    <rect x="7" width="1" height="8" fill="black" />
  </svg>
);
